import { Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { AccessScopeDto, type AccessGrantDto } from "../../../../autogen/bff-api";
import { useGrantRoleName } from "./useGrantRoleName";

interface Props {
  personName: string;
  grants: AccessGrantDto[];
}

export const EntraDefaultRoleLossWarning = ({ personName, grants }: Props) => {
  const { t } = useTranslation();
  const roleName = useGrantRoleName();
  const defaultRoleGrants = grants.filter((grant) => grant.fromEntraDefaultRole);
  if (!defaultRoleGrants.length) return null;

  const where = (grant: AccessGrantDto) =>
    grant.scope === AccessScopeDto.Organization
      ? t("The whole organization")
      : grant.departmentName || t("Unknown department");

  return (
    <Text fontSize="sm" color="smWarning">
      {t(
        "This takes {{person}} off the Entra ID default role ({{grants}}). Later changes to the default role will no longer reach {{person}}.",
        {
          person: personName,
          grants: defaultRoleGrants.map((grant) => `${roleName(grant.role)} · ${where(grant)}`).join(", "),
        },
      )}
    </Text>
  );
};
